export const calculatePercentage = (
  count: number,
  total: number,
  fractionDigits = 0,
) => {
  if (total > 0) {
    return Number(((count / total) * 100).toFixed(fractionDigits));
  }
  return 0;
};

const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

export const formatBytes = (bytes: number) => {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    BYTE_UNITS.length - 1,
  );
  const value = bytes / 1024 ** exponent;
  return `${Number(value.toFixed(1))} ${BYTE_UNITS[exponent]}`;
};

export const formatCount = (value: number) =>
  new Intl.NumberFormat('en-US').format(value);
